import template from './user_edit.html'
import UserSettings from '../../lib/UserSettings.js';

class dashboard_UserEditViewModel
{
	constructor (dialog)
	{
		this.dialog = dialog;

		let last_user_tab = localStorage.getItem('last_user_tab') || 'personal_info';
		this.selected_tab = ko.observable(last_user_tab);

		this.show_advanced_roles = ko.observable(false);
		this.roleTypeMap = {};
		this.roleDisplayNameMap = {};
		this.allGroupNames = ko.observableArray();
		this.availableGroupNames = ko.observableArray();
		this.selectedAvailableGroupNames = ko.observableArray();
		this.selectedCurrentGroupNames = ko.observableArray();
		this.currentGroupNames = ko.observableArray([]);

		this.allAdvancedRoleNames = ko.observableArray();
		this.availableAdvancedRoleNames = ko.observableArray();
		this.selectedAvailableAdvancedRoleNames = ko.observableArray();
		this.selectedCurrentAdvancedRoleNames = ko.observableArray();
		this.currentAdvancedRoleNames = ko.observableArray([]);

		this.availableGroupOptions = ko.pureComputed(() =>
			(this.availableGroupNames() || []).map((roleName) => ({
				role_name: roleName,
				display_name: this.get_role_display_name(roleName)
			}))
		);
		this.currentGroupOptions = ko.pureComputed(() =>
			(this.currentGroupNames() || []).map((roleName) => ({
				role_name: roleName,
				display_name: this.get_role_display_name(roleName)
			}))
		);
		this.availableAdvancedRoleOptions = ko.pureComputed(() =>
			(this.availableAdvancedRoleNames() || []).map((roleName) => ({
				role_name: roleName,
				display_name: this.get_role_display_name(roleName)
			}))
		);
		this.currentAdvancedRoleOptions = ko.pureComputed(() =>
			(this.currentAdvancedRoleNames() || []).map((roleName) => ({
				role_name: roleName,
				display_name: this.get_role_display_name(roleName)
			}))
		);

		this.currentGroupNames.subscribe(() => this.updateAvailableRoles());
		this.currentAdvancedRoleNames.subscribe(() => this.updateAvailableRoles());

		this.availableAuthenticationServers = ko.observableArray();
		this.is_user_loaded = ko.observable(false);
		this.user_id = ko.observable();
		this.enable_username_edit = ko.observable(false);
		this.enable_email_edit = ko.observable(false);

		// "Details" tab
		this.username = ko.observable('');
		this.email = ko.observable('');
		this.fullnames = ko.observable('');
		this.given_name = ko.observable('');

		this.user_settings = ko.observable();
		this.user_setting_list = ko.pureComputed(() => {
			if (this.user_settings())
				return this.user_settings().get_sorted_array();
			else
				return [];
		});

		this.otp_methods = ko.observableArray([]);

		this.new_password = ko.observable('');
		this.active = ko.observable(true);
		this.pending = ko.observable(false);
		this.uuid = ko.observable('');

		this.auth_mech = ko.observable('');
		this.availableAuthenticationMethods = ko.observableArray(['local', 'remote']);
		this.auth_service_name = ko.observable('');
		this.auth_service = ko.observable();

		this.sessions = ko.observableArray([]);
		this.api_keys = ko.observableArray([]);

		this.title = ko.computed(() => {
			if (!this.username() || this.username() === '') {
				return 'Create user';
			}
			return `Editing user ${this.username()}`;
		}, this);
		this.access_roles = ko.observableArray([]);
	}

	set_access_roles (access_roles)
	{
		const groups = [];
		const advancedRoles = [];
		this.roleTypeMap = {};
		this.roleDisplayNameMap = {};
		for (const role of (access_roles || []))
		{
			this.roleTypeMap[role.role_name] = role.role_type;
			this.roleDisplayNameMap[role.role_name] = role.display_name || role.role_name;
			if (role.role_type == 'GROUP')
				groups.push(role.role_name);
			else
				advancedRoles.push(role.role_name);
		}
		this.allGroupNames(groups.sort((a, b) => this.get_role_display_name(a).localeCompare(this.get_role_display_name(b))));
		this.allAdvancedRoleNames(advancedRoles.sort((a, b) => this.get_role_display_name(a).localeCompare(this.get_role_display_name(b))));
		this.updateAvailableRoles();
	}

	get_role_display_name (roleName)
	{
		return this.roleDisplayNameMap[roleName] || roleName;
	}

	load_roles_for_user (user_roles)
	{
		const currentGroups = [];
		const currentAdvancedRoles = [];
		for (const roleName of (user_roles || []))
		{
			if (this.roleTypeMap[roleName] == 'GROUP')
				currentGroups.push(roleName);
			else
				currentAdvancedRoles.push(roleName);
		}
		this.currentGroupNames(currentGroups);
		this.currentAdvancedRoleNames(currentAdvancedRoles);
		this.updateAvailableRoles();
	}

	updateAvailableRoles ()
	{
		const currentGroups = this.currentGroupNames() || [];
		const allGroups = this.allGroupNames() || [];
		this.availableGroupNames(allGroups.filter((roleName) => currentGroups.indexOf(roleName) < 0));

		const currentAdvancedRoles = this.currentAdvancedRoleNames() || [];
		const allAdvancedRoles = this.allAdvancedRoleNames() || [];
		this.availableAdvancedRoleNames(allAdvancedRoles.filter((roleName) => currentAdvancedRoles.indexOf(roleName) < 0));
	}

	get_selected_role_names ()
	{
		return [...new Set([]
			.concat(this.currentGroupNames() || [])
			.concat(this.currentAdvancedRoleNames() || [])
		)];
	}

	formatSettingName(name)
	{
		if (!name) return '';
		// Replace underscores with spaces and capitalize first letter
		return name.replace(/_/g, ' ').replace(/^\w/, c => c.toUpperCase());
	}

	switch_tabs (data, event)
	{
		let tabname = event.currentTarget.getAttribute('data-tabname');
		this.selected_tab(tabname);

		localStorage.setItem('last_user_tab', tabname);

		document.querySelectorAll('.ps-nav-pill li').forEach(tab => tab.classList.remove('active'));
		event.currentTarget.classList.add('active');
	}

	async load (user_id)
	{
		this.user_id(user_id);
		let response = await fetch(`/api/user/${user_id}`);
		let data = await response.json();
		if (!data || data.status != 'OK')
		{
			Grape.alert_api_error(data);
			return;
		}

		const user = data.user;
		this.username(user.username);
		this.active(user.active);
		this.email(user.email);
		this.uuid(user.uuid);
		this.load_roles_for_user(user.assigned_role_names || user.user_roles);
		
		// Load fullnames and given_name from API response (they are in user.settings)
		this.fullnames(user.settings?.fullnames || '');
		this.given_name(user.settings?.given_name || '');

		const user_settings = new UserSettings(undefined, this.username());
		user_settings.set_values(user.settings);
		this.user_settings(user_settings);

		this.otp_methods(user.settings?.otp_methods || []);

		this.auth_service_name(user.auth_service_name);

		const auth_info = user.auth_info;
		this.auth_mech(auth_info.auth_mech);
		if (auth_info.auth_mech == 'remote' && auth_info.auth_params)
		{
			let auth_service_uuid = auth_info.auth_params.uuid;
			let item = this.availableAuthenticationServers().find((x) => { return x.service_uuid==auth_service_uuid; });
			if (item)
				this.auth_service(item);
		}

		await [
			this.load_sessions(),
			this.load_api_keys(),
			this.load_user_settings_lookup()
		];
	}

	async load_user_settings_lookup ()
	{
		let data = await Grape.cache.fetch('UserSettings');
		this.user_settings().set_settings(data);
		
		// Ensure required settings exist even if they're not in user settings
		const required_settings = [
			'fullnames',
			'family_name',
			'given_name',
			'picture',
			'delegation_code',
			'picture_filename',
			'delegation_expiry',
			'delegation_username',
			'theme',
			'locale',
			'theme_mode'
		];
		
		for (const setting_name of required_settings) {
			const setting = this.user_settings().get(setting_name);
			if (!setting) {
				// Create blank setting if it doesn't exist
				this.user_settings().set_setting(setting_name, {
					active: true,
					idx: 999, // High index so they appear at the end
					tags: ['user_save'],
					value: ''
				});
			} else if (setting.value === undefined || setting.value === null) {
				// Ensure value is set to empty string if undefined/null
				setting.value = '';
			}
		}
		
		this.user_settings.notifySubscribers();
	}

	async load_sessions ()
	{
		let session_data = await Grape.fetches.getJSON('/api/record', {
			table: 'v_active_sessions',
			schema: 'users',
			filter: [{field: 'user_uuid', operator: '=', value: this.uuid()}]
		});
		if (session_data.hasOwnProperty('records'))
			this.sessions(session_data.records);
	}

	async load_api_keys ()
	{
		let data = await Grape.fetches.getJSON('/api/record', {
			table: 'v_api_keys_config',
			schema: 'users',
			filter: [{
				field: 'user_uuid',
				operator: '=',
				value: this.uuid()
			}]
		});
		let records = [];
		for (let r of (data.records || []))
			records.push({
				name: r.name,
				roles: r.attributes?.roles || [],
				description: r.attributes.description,
				date_inserted: r.date_inserted,
				last_used: r.last_used,
				uuid: r.api_key_uuid
			});

		this.api_keys(records);
	}

	async end_session_click (row)
	{
		let response = await fetch(`/api/session/logout?session_uuid=${row.session_uuid}`);

		if (Grape.currentSession.session_uuid == row.session_uuid)
		{
			this.dialog.close();
			Grape.navigate('/ui/logout');
		}
		else
			this.load_sessions();
	}

	async detele_api_key_click (apikey)
	{
		if (!(await Grape.alerts.confirm({type: 'warning', title: 'Delete API Key', message: 'Are you sure?'})))
			return;

		try {
			let response = await fetch(`/api/apikey/${apikey.uuid}`, {
				method: 'DELETE'
			});

			if (!response.ok)
				throw new Error(response.message);
			else
				Grape.alerts.alert({type: 'success', title: 'success', message: 'API key has been deleted'});
		} catch (err) {
			Grape.alerts.alert({type: 'error', title: 'Error', message: err.message });
			console.error(err);
		} finally {
			this.load_api_keys();
		}
	}

	btnSave_click ()
	{
		const obj = {
			user_id: this.user_id(),
			username: this.username(),
			email: this.email(),
			fullnames: this.fullnames(),
			given_name: this.given_name(),
			active: this.active(),
			pending: this.pending(),
			uuid: this.uuid(),
			role_names: this.get_selected_role_names(),
			auth_mech: this.auth_mech(),
			password: null,
			otp_methods: this.otp_methods()
		};

		if (this.auth_service())
		{
			obj.auth_service_params = {
				name: this.auth_service().service_name,
				uuid: this.auth_service().service_uuid
			};
		}

		// Load setting values from inputs into obj
		if (this.user_settings())
			for (let [k, v] of this.user_settings().entries())
				if (v.tags.indexOf('user_save') > -1 && v.input() != v.value)
					obj[k] = v.input();

		// Set new password if changed
		if (this.new_password() != '')
			obj.password = this.new_password();

		if (obj.username == '')
			Grape.alerts.alert({type: 'error', title: 'Missing fields', message: 'Username is a compulsory field'});
		else
		{
			if (obj.uuid == '')
				delete obj.uuid ;
			this.dialog.close(obj);
		}
	}

	/**
	 * Remove OTP button
	 */
	async removeOTP_click (otp_method)
	{
		if (await Grape.alerts.confirm({type: 'warning', title: '', message: ''}))
		{
			const new_otp_methods = this.otp_methods().filter((x) => x != otp_method);
			this.otp_methods(new_otp_methods);
		}
	}

	btnClose_click ()
	{
		this.dialog.close();
	}

	btnRemoveGroups_click ()
	{
		let currentGroups = this.currentGroupNames();
		const groupsToRemove = this.selectedCurrentGroupNames();
		currentGroups = currentGroups.filter((roleName) => !groupsToRemove.includes(roleName));
		this.currentGroupNames(currentGroups);
		this.selectedCurrentGroupNames([]);
	}

	btnAddGroups_click ()
	{
		let currentGroups = this.currentGroupNames();
		if (!currentGroups)
			currentGroups = [];
		this.currentGroupNames(currentGroups.concat(this.selectedAvailableGroupNames()));
		this.selectedAvailableGroupNames([]);
	}

	btnRemoveAdvancedRoles_click ()
	{
		let currentAdvancedRoles = this.currentAdvancedRoleNames();
		const rolesToRemove = this.selectedCurrentAdvancedRoleNames();
		currentAdvancedRoles = currentAdvancedRoles.filter((roleName) => !rolesToRemove.includes(roleName));
		this.currentAdvancedRoleNames(currentAdvancedRoles);
		this.selectedCurrentAdvancedRoleNames([]);
	}

	btnAddAdvancedRoles_click ()
	{
		let currentAdvancedRoles = this.currentAdvancedRoleNames();
		if (!currentAdvancedRoles)
			currentAdvancedRoles = [];
		this.currentAdvancedRoleNames(currentAdvancedRoles.concat(this.selectedAvailableAdvancedRoleNames()));
		this.selectedAvailableAdvancedRoleNames([]);
	}
}

class UserEditDialog
{
	constructor (bindings)
	{
		this.viewModel = new dashboard_UserEditViewModel(this);
		this.name = 'UserEditDialog'
		this.bindings = bindings;

		let last_user_tab = localStorage.getItem('last_user_tab') || 'personal_info';
		document.querySelector(`.ps-nav-pill li[data-tabname='${last_user_tab}']`).classList.add('active');

		this.init();
	}

	async init ()
	{
		let access_roles = await Grape.cache.fetch('AccessRoles');
		this.viewModel.set_access_roles(access_roles);

		const auth_services_res = await Grape.fetches.getJSON('/api/auth-services');
		this.viewModel.availableAuthenticationServers(auth_services_res.services);

		if (this.bindings && this.bindings.user_id)
		{
			this.viewModel.load(this.bindings.user_id);
		}
		else
		{
			this.viewModel.currentGroupNames([]);
			this.viewModel.currentAdvancedRoleNames([]);
			this.viewModel.enable_email_edit(true);
			this.viewModel.enable_username_edit(true);
			this.viewModel.user_id(null);
			
			// Initialize user_settings for new user
			const user_settings = new UserSettings(undefined, '');
			this.viewModel.user_settings(user_settings);
			await this.viewModel.load_user_settings_lookup();
		}
	}
}

export default {
	name: 'UserEdit',
	dialog_class: UserEditDialog,
	template: template,
	provider: "ps"
}
